import PositionsView from "../PositionsView.vue";
import PositionList from "../Pages/PositionList.vue";
import PositionEditor from "../Pages/PositionEditor.vue";

const routes = [
  {
    path: '/cargos',
    component: PositionsView,
    children: [
      {
        path: '',
        name: 'position-list',
        component: PositionList,
      },
      {
        path: 'crear',
        name: 'position-create',
        component: PositionEditor,
      },
      {
        path: ':id',
        name: 'position-edit',
        component: PositionEditor
      },
    ]
  }
]

export default routes
